import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/4aa7700c01a2a06640654e7632c5fa8b.png" 
              alt="Evolution Home Renovations" 
              className="h-20 w-auto object-contain hover:scale-105 transition-transform duration-300"
            />
            <p className="text-gray-300 text-lg max-w-md">
              Transforming homes with luxury renovations since 2019. Over 350 projects completed with excellence and premium craftsmanship.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-red-600">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-300 hover:text-red-600 transition-colors cursor-pointer">Home</Link>
              <Link to="/about" className="block text-gray-300 hover:text-red-600 transition-colors cursor-pointer">About</Link>
              <Link to="/gallery" className="block text-gray-300 hover:text-red-600 transition-colors cursor-pointer">Gallery</Link>
              <Link to="/services" className="block text-gray-300 hover:text-red-600 transition-colors cursor-pointer">Services</Link>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-red-600">Contact</h4>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-red-600"></i>
                </div>
                <span className="text-gray-300">416-602-6019</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-red-600"></i>
                </div>
                <span className="text-gray-300">evolution.home.inc@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-user-line text-red-600"></i>
                </div>
                <span className="text-gray-300">Humraj Singh</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-red-600"></i>
                </div>
                <span className="text-gray-300">24 hours</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-instagram-line text-red-600"></i>
                </div>
                <a 
                  href="https://www.instagram.com/evolutionhomes.inc/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-red-600 transition-colors cursor-pointer"
                >
                  @evolutionhomes.inc
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          {/* Logo Section */}
          <div className="flex justify-center mb-8">
            <img 
              src="https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/4aa7700c01a2a06640654e7632c5fa8b.png" 
              alt="Evolution Home Renovations" 
              className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
            />
          </div>
          
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 Evolution Home. All rights reserved.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-6 mt-4 md:mt-0">
              {/* Pockitt Branding - Enhanced with Box */}
              <div className="bg-gray-800 border-2 border-red-600/30 rounded-lg p-6 shadow-lg hover:border-red-600/50 transition-all duration-300">
                <div className="text-center">
                  <div className="text-xl font-semibold mb-4 text-gray-300">Website designed, built, maintained and hosted by</div>
                  <a 
                    href="https://pockitt.info/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-4xl font-bold text-red-600 hover:text-red-500 hover:scale-110 transition-all duration-300 cursor-pointer tracking-wide drop-shadow-lg hover:drop-shadow-xl"
                  >
                    Pockitt
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}
